/*  JS of Price Filter
    Added by Wilson from Galadrim  */

(() => {
  "use strict";

  /* ---------- Initial formatting ---------- */
  function formatPriceInputsToEuros() {
    document.querySelectorAll(".collection-filters__price-range-form").forEach(form => {
      const minInput = form.querySelector('input[name*="min"]');
      const maxInput = form.querySelector('input[name*="max"]');
      const centsToEuros = input => {
        if (input && input.value && !isNaN(input.value)) {
          const val = parseInt(input.value.replace(/[^0-9]/g, ""), 10);
          input.value = (val >= 100 ? (val / 100).toFixed(2) : input.value).replace(",", ".");
        }
      };
      centsToEuros(minInput);
      centsToEuros(maxInput);
    });
  }
  document.addEventListener("DOMContentLoaded", formatPriceInputsToEuros);
  document.addEventListener("shopify:section:load", formatPriceInputsToEuros);

  /* ---------- Observer to keep the format ---------- */
  function forcePriceInputsEurosWithObserver() {
    const applyFormatting = () => {
      document.querySelectorAll(".collection-filters__price-range-form").forEach(form => {
        const min = form.querySelector('input[name*="min"]');
        const max = form.querySelector('input[name*="max"]');
        [min, max].forEach(input => {
          if (input && input.value && !isNaN(input.value)) {
            const v = parseInt(input.value.replace(/[^0-9]/g, ""), 10);
            input.value = (v >= 100 ? (v / 100).toFixed(2) : input.value).replace(",", ".");
          }
        });
      });
    };

    applyFormatting(); // initial
    const target = document.querySelector("[data-productgrid-sidebar]") || document.body;
    new MutationObserver(applyFormatting).observe(target, { childList: true, subtree: true, attributes: true });
  }
  document.addEventListener("DOMContentLoaded", forcePriceInputsEurosWithObserver);
  document.addEventListener("shopify:section:load", forcePriceInputsEurosWithObserver);

  /* ---------- Custom price range radios ---------- */
  function initCustomPriceRadios() {
    const customRadios = document.querySelectorAll('.custom-price-ranges input[type="checkbox"]');

    if (!customRadios.length) return;

    customRadios.forEach(radio => {
      // Prevent adding multiple listeners if re-initialized
      if (radio.hasAttribute("data-price-filter-initialized")) return;
      radio.setAttribute("data-price-filter-initialized", "true");

      radio.addEventListener("change", e => {
        // Find the current URL
        const url = new URL(window.location.href);

        // Remove any existing price filters from the URL
        url.searchParams.delete("filter.v.price.gte");
        url.searchParams.delete("filter.v.price.lte");

        // If the clicked checkbox is now checked
        if (radio.checked) {
          // Uncheck any other price checkboxes
          customRadios.forEach(otherRadio => {
            if (otherRadio !== radio) otherRadio.checked = false;
          });

          // Get the min/max values from the data attributes
          const min = radio.dataset.min;
          const max = radio.dataset.max;

          // Add the new price filters to the URL
          if (min) {
            url.searchParams.set("filter.v.price.gte", min);
          }
          if (max) {
            url.searchParams.set("filter.v.price.lte", max);
          }
        }

        // Trigger a full page navigation to the new URL
        window.location.href = url.toString();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initCustomPriceRadios);
  document.addEventListener("shopify:section:load", initCustomPriceRadios);
})();
